import {
  AppBar,
  Button,
  Container,
  Divider,
  Grid,
  InputBase,
  Stack,
  Toolbar,
  IconButton,
  Typography,
  Select,
  OutlinedInput,
  Box,
  Chip,
  MenuItem,
  SelectChangeEvent,
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableContainer,
  Paper,
  Pagination,
  Dialog,
  DialogTitle,
  DialogActions,
  Snackbar,
  Backdrop,
  Breadcrumbs,
  Link,
  CircularProgress,
} from "@mui/material";
import Cookies from "universal-cookie";
import SettingsSuggestIcon from "@mui/icons-material/SettingsSuggest";
import * as React from "react";
import BusinessIcon from "@mui/icons-material/Business";
import { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import axios, { AxiosInstance } from "axios";
import { IPays, StyledTableCell, tableStyle } from "../Pays/Pays";
import MuiAlert, { AlertProps } from "@mui/material/Alert";
import { http } from "../../../../utils/Http";
import ClientPereRow from "./ClientPereRow";
import AccessibilityIcon from "@mui/icons-material/Accessibility";
import { IClient } from "../Client/InterfaceClient";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

export const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};
export interface IClientParent {
  id: number
  libelle: string
  date_suppression: any
  created_at: string
  updated_at: string
  clients: IClient[]
}

const urlBaseApi = process.env.REACT_APP_BASE_API_URL as string;

const ClientPere = () => {
  const [openSelectMultiple, setOpenSelectMultiple] = useState<boolean>(false);
  const [allClient, setAllClient] = useState<IClient[]>([]);
  const [allClientPeresRows, setAllClientPeresRows] = useState<IClientParent[]>([]);

  const [libelleSearch, setLibelleSearch] = useState<string>("");
  const [libelleAjouter, setLibelleAjoute] = useState<string>("");

  const [clientsIdArrayToSave, setclientsIdArrayToSave] = useState<string[]>(
    []
  );
  const [nb, setNb] = useState(0);
  const [rowPerPage, setRowPerPage] = useState(5);
  const [page, setPage] = useState<number>(1);

  const cookies = new Cookies();
  const token: string = cookies.get("jwt");

  const http: AxiosInstance = axios.create({
    baseURL: urlBaseApi,
    // timeout: 1000,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const handleCloseSelectMulti = () => {
    setOpenSelectMultiple((prev) => !prev);
  };

  const handleChange = (
    event: SelectChangeEvent<typeof clientsIdArrayToSave>
  ) => {
    const {
      target: { value },
    } = event;

    setclientsIdArrayToSave(
      // On autofill we get a stringified value.
      typeof value === "string" ? value.split(",") : value
    );
  };

  const transformValue = (id: number): string => {
    const pays = allClient?.find((elem) => elem?.id === id);

    return `${pays?.id} - ${pays?.libelle}`;
  };

  const getDataClient = () => {
    const data = {};
    http
      .post("get/client", data)
      .then((res) => {
        const { total, data } = res.data;
        console.log(data); // Array.isArray(data) && setCouts(data);
        setAllClient(data);
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        // setIsLoading(false);
      });
  };

  const getAllClientParent = () => {
    const data = {
      rowPerPage: rowPerPage,
      page: page,
      idClient: 0,
    };

    http
    .post("get/client/parent", data)
    .then((res) => {
      const { total, data } = res.data;
      console.log(data); // Array.isArray(data) && setCouts(data);
      setAllClientPeresRows(data);
      setNb(total);
    })
    .catch((error) => {
      console.log(error);
    })
    .finally(() => {
      // setIsLoading(false);
    });

  };

  const ClickSave = () => {
    const data = {
      libelle: libelleAjouter,
      arrayIdClientChild: clientsIdArrayToSave,
    };

    http
      .post("create/client/parent", data)
      .then((res) => {
        console.log(res.data);
        window.location.reload();
      })
      .catch((error) => {
        console.log(error);
      })
      .finally(() => {
        // setIsLoading(false);
      });

    console.log(data);
  };

  useEffect(() => {
    getDataClient();
  }, []);

  useEffect(() => {
    getAllClientParent();
  },[page,rowPerPage])
  return (
    <>
      <AppBar
        position="static"
        sx={{
          backgroundColor: "#FC8404",
        }}
      >
        <Container>
          <Toolbar disableGutters>
            <Breadcrumbs aria-label="breadcrumb" sx={{ color: "#fff", ml: 2 }}>
              <Link
                underline="hover"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  fontWeight: "bold",
                }}
                color="inherit"
                href="#"
              >
                <SettingsSuggestIcon sx={{ mr: 1 }} fontSize="medium" />
                Paramètrage
              </Link>
              <Typography
                sx={{ display: "flex", alignItems: "center" }}
                // color="text.primary"
              >
                <AccessibilityIcon sx={{ mr: 1 }} fontSize="medium" />
                Parent Client
              </Typography>
            </Breadcrumbs>
          </Toolbar>
        </Container>
      </AppBar>

      <Container maxWidth="lg">
        <Stack>
          <Divider sx={{ my: 4 }} />
          <Grid container>
            <Grid item xs={7}>
              <Typography sx={{ display: "flex" }}>
                <Select
                  labelId="demo-multiple-chip-label"
                  id="demo-multiple-chip"
                  multiple
                  displayEmpty
                  label="Code Gesco"
                  size="small"
                  sx={{
                    background: "#FC8404",
                    color: "red",
                  }}
                  color="warning"
                  open={openSelectMultiple}
                  onClick={() => handleCloseSelectMulti()}
                  value={clientsIdArrayToSave}
                  onChange={handleChange}
                  input={
                    <OutlinedInput id="select-multiple-chip" label="Chip" />
                  }
                  renderValue={(selected) => (
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                      {selected.map((value) => (
                        <Chip key={value} label={value} />
                      ))}
                    </Box>
                  )}
                  MenuProps={MenuProps}
                >
                  {allClient.map((client) => (
                    <MenuItem
                      sx={{
                        background: "#FC8404",
                      }}
                      key={client?.id}
                      value={transformValue(client?.id as number)}
                    >
                      {client?.id} - {client?.libelle}
                    </MenuItem>
                  ))}
                </Select>
                <InputBase
                  sx={{ ml: 4, flex: 1, color: "white" }}
                  value={libelleAjouter}
                  placeholder="Ajouter un Client Pere"
                  onChange={(e) => setLibelleAjoute(e.target.value)}
                  size="small"
                />
              </Typography>
            </Grid>
            <Grid item xs={2}>
              <Button
                variant="contained"
                color="warning"
                startIcon={<AddIcon />}
                onClick={ClickSave}
                style={{ textTransform: "none" }}
              >
                Ajouter
              </Button>
            </Grid>
            <Grid item xs={3}>
              <Typography sx={{ display: "flex" }}>
                <InputBase
                  sx={{ ml: 4, flex: 1, color: "white" }}
                  value={libelleSearch}
                  placeholder="Chercher un Client Père"
                  onChange={(e) => setLibelleSearch(e.target.value)}
                  fullWidth
                />
                <Grid item xs={2}>
                  <IconButton
                    type="submit"
                    sx={{ p: "10px", color: "white" }}
                    aria-label="search"
                    // onClick={ClickSearch}
                  >
                    <SearchIcon />
                  </IconButton>
                </Grid>
              </Typography>
            </Grid>
          </Grid>
        </Stack>
        <Divider sx={{ my: 2 }} />
        <Box
          sx={{
            minHeight: 530,
          }}
        >
          <TableContainer component={Paper} style={tableStyle}>
            <Table>
              <TableHead>
                <TableRow>
                  <StyledTableCell align="center">Client Père</StyledTableCell>
                  <StyledTableCell align="center">Client</StyledTableCell>
                  <StyledTableCell align="center">Action</StyledTableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {allClient.map((row) => (
                  /*<RowBu
                    row={row}
                    allPays={allPays}
                    setOpen={setOpen}
                    seIdToDeleted={seIdToDeleted}
                  />*/<></>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Box justifyContent="right" display="flex" mt={3} mr={6}>
            <Stack spacing={2}>
              <Pagination
                sx={{ button: { color: "white" } }}
                count={Math.ceil(nb / rowPerPage)}
                color="standard"
                showFirstButton={true}
                showLastButton={true}
                defaultPage={page}
                onChange={(event, value) => setPage(value)}
              />
            </Stack>
          </Box>
        </Box>
      </Container>
    </>
  );
};

export default ClientPere;
